import {useMutation, gql} from '@apollo/client'

const MUTATE_REMOVE_USER = gql`
  mutation MUTATE_REMOVE_USER($groupId: Numeric!, $email: Email!, $jurisdiction: [Int], $filters: [String]) {
    removeUser(groupId: $groupId, email: $email, jurisdiction: $jurisdiction, filters: $filters) {
      removeUser {
        group_id
        email
      }
    }
  }
`

export function useRemoveUser() {
  return useMutation(MUTATE_REMOVE_USER, {
    context: {clientName: 'adminPanel'}
  })
}
